import { getTheme, styled } from '~/modules';
import { mqDevices } from '~/utils';
import Typography from '../Typography';

const spacingSm = getTheme('spacing.sm');

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: ${spacingSm}px;

  @media ${mqDevices.inMobileAndTablet} {
    justify-content: center;
  }
`;
export const WrapperLetter = styled.div`
  p {
    font-size: 24px;
  }
`;

export const Name = styled(Typography).attrs({ variant: 'md' })`
  width: 90%;
  font-weight: bold;
  text-align: center;
`;

export const UserName = styled(Typography).attrs({ variant: 'xs' })`
  width: 90%;
  text-align: center;
`;
